import { tracking } from '@iwoca/frontend-tracking-library';

import {
  checkHasThirtyDayAndThreeMonthLimit,
  formatDuration,
} from './duration.helpers';
import { SpendingLimitBar } from './SpendingLimitBar';
import { useGetBuyerSpendingLimit } from '../../../../../api/lending/lapiHooks';
import { useGetFlexiLoanAmount } from '../../../Dashboard.helpers';
import { useGetSpendingLimits } from '../../../hooks/useGetSpendingLimits';
import { formatCurrency } from '../../../utils/currency';

export const ValidLimits = ({
  setIsSpendingLimitDrawerOpen,
}: {
  setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { spendingLimit, loadingSpendingLimit } = useGetBuyerSpendingLimit();
  const { flexiLoanAmount, loadingFlexiLoanAmount } = useGetFlexiLoanAmount();
  const { spendingLimits } = useGetSpendingLimits();

  const activeSpendingLimit = spendingLimit?.data?.active_spending_limit;

  if (loadingSpendingLimit || !activeSpendingLimit || loadingFlexiLoanAmount)
    return null;

  const hasThirtyDayAndThreeMonthLimit = checkHasThirtyDayAndThreeMonthLimit(
    spendingLimits?.limits || [],
  );

  return (
    <div className="gap-y-6 max-sm:grid-cols-1 max-sm:gap-y-4 max-sm:[grid-template-areas:'left'_'bar'_'right'] grid grid-cols-[1fr_auto] [grid-template-areas:'left_right'_'bar_bar']">
      <div className="[grid-area:left]">
        <div className="gap-2 max-sm:text-xl flex flex-wrap items-center text-2xl font-reg">
          <div>
            You have{' '}
            <span className="font-bold">
              {formatCurrency(activeSpendingLimit.available_amount)}
            </span>{' '}
            left to spend
          </div>
        </div>
        {activeSpendingLimit.max_amount === 150 && flexiLoanAmount && (
          <div className="my-2 text-s font-reg text-structure-40">
            *Your available spending is limited due to active loans.
          </div>
        )}
        <div className="text-s font-reg">
          *Interest rate is dependent on supplier
        </div>
      </div>
      <div className="max-sm:justify-self-start justify-self-end [grid-area:right]">
        <div className="gap-2 max-sm:justify-start max-sm:font-reg flex flex-wrap justify-end text-s font-med">
          Spending limit: {formatCurrency(activeSpendingLimit.max_amount)}
        </div>
        <div className="max-sm:text-left text-right text-xs font-reg">
          {formatDuration({
            duration: activeSpendingLimit.duration_in_months,
            groupSameLimits: hasThirtyDayAndThreeMonthLimit,
          })}{' '}
          purchases{' '}
          <button
            onClick={() => {
              tracking.ampli.spendingLimitViewedOtherTerms();
              setIsSpendingLimitDrawerOpen(true);
            }}
            className="ml-1 cursor-pointer border-none bg-transparent bg-none p-0 text-xs text-[color:var(--color-primary-40,#4b4bff)] underline"
          >
            Other terms
          </button>
        </div>
      </div>
      <div className="mt-m [grid-area:bar]">
        <SpendingLimitBar status="valid" />
      </div>
    </div>
  );
};
